import { AbstractBet } from '@/models/abstractBet';
import { IBetDataAPI } from '@/types';

export class BetFailItem extends AbstractBet {
    public error: string;

    constructor(data: IBetDataAPI) {
        super(data);
        this.error = data.error ?? '';
    }

    get isBet(): boolean {
        return false;
    }

    get isFail(): boolean {
        return true;
    }

    get message(): string {
        return this.error;
    }
}
